import Marionette from 'backbone.marionette';
import viewMixins from './core/internal/viewMixins';

export default Marionette.CompositeView.extend(viewMixins(Marionette.CompositeView));
